<template>
    <div class="map" :id="initId">
        <div class="legend-my">
            <canvas id="legend" class="legend-show" ></canvas>
            <div class="right">
                <p>{{legendObj.endValue}}</p>
                <p>{{legendObj.startValue}}</p>
            </div>
        </div>
        <!-- <div class="time-step">
            <StepV :arrayList="AllCollection" :arrayIndex="layerIndex" :showSFM="true"/>
        </div> -->
    </div>
</template>

<script>
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import 'leaflet-draw'
// import StepV from "@/components/Steps"
import axios from '@/utils/axios.min'

import 'leaflet-velocity/dist/leaflet-velocity.css'
import 'leaflet-velocity/dist/leaflet-velocity'

import DrawPlug from "@/utils/measure"
import {tiledMapLayer} from '@supermap/iclient-leaflet';
import {addLeafletLayerFromOption} from "@/utils/convert"
import { colorpicks} from "@/utils/common"
export default {
    props:{
        initId:{
            type:String,
            default:'map'
        },
        timeRange:{
            type:Array
        },
        isplay:{
            type:Boolean
        },
        is2d:{
            type:Boolean
        },
        url: {
          type: String
        },
       collections: {
          type: Array
       },
       legendObj:{
           type:Object
       }
    },
    components:{
        // StepV
    },
    data(){
        return{
            draw:null,
            baseMap:null,
            AllCollection:[],
            timer:null,
            startTime:'',
            endTime:'',
            TimeLayerGroup:null,
            lalayerIDlist:[],
            layerIndex: 0,
            isFirst:true,
            loading:false,
            showWind:false,
            initWind:false,
            windLayerGroup:null,
            measureGroup:null,
            timelist:[],
            layerIdList:[],
            currentParams:{}
        }
    },
    watch:{
        timeRange(val){
            if(val){
                this.layerIndex = 0
                this.getTimeList()
            }
        },
        isplay(val){
            if(!val&&!this.is2d){
                this.TimeLayerGroup.clearLayers()
                this.layerIndex = 0
                this.newTimeAnimation()
            }else{
                clearInterval(this.timer)
            }
        }
    },
    destroyed(){
        clearInterval(this.timer)
    },
    methods:{
        renderLegend(){
            let c_list = this.legendObj.principalValue.split(',')
            let a = colorpicks(c_list,100)
            var can = document.getElementById("legend");
            var cans = can.getContext('2d');
            //创建一个线性渐变对象
            var gnt1 = cans.createLinearGradient(0,160,0,0);
            a.forEach((element,index) => {
                gnt1.addColorStop(index*(1/a.length),element);
            });
            cans.fillStyle = gnt1;
            //绘制一个矩形
            cans.fillRect(0,0,240,160);
        },
        ceju(){
            let draw= new DrawPlug(this.baseMap,this.measureGroup)
            draw.startDrawLine()
        },
        cemian(){
            let draw= new DrawPlug(this.baseMap,this.measureGroup)
            draw.startDrawPolygon()
        },
        changeTime(time){
          let now = new Date(time),
              Y = now.getFullYear(),
              M = now.getMonth()+1,
              D= now.getDate()
            M = M<10?'0'+M:M;
            D = D<10?'0'+D:D;
            return Y+'-'+M+'-'+D;
        },
        newTimeAnimation(){
            let that = this
            this.timer = setInterval(() =>{
                if(that.loading){
                    return
                }
                let b = tiledMapLayer(that.iserverHeader +that.url + '/'+ that.collections[0].resourceName, {
                    noWrap: true,
                    layersID:that.layerIdList[that.layerIndex]
                }).addTo(this.TimeLayerGroup);
                that.lalayerIDlist.push(b._leaflet_id)
                if(that.lalayerIDlist.length>2){
                    that.TimeLayerGroup.removeLayer(that.lalayerIDlist.shift())
                }
                if (that.layerIndex === that.layerIdList.length - 1) {
                    that.layerIndex = 0
                    clearInterval(that.timer)
                    that.clearCacheLayer()
                    return
                }
                that.layerIndex++

            },400)
        },
        async initMap(){
            let that = this
            let crs  = L.CRS['EPSG'+that.collections[0].baseUnderUrl]
            if(crs){
                that.baseMap = L.map(that.initId, {
                    center: [0,0],
                    maxZoom: 18,
                    crs:crs,
                    zoomControl:false,
                    attributionControl:false,
                    zoom: 1,
                });
            }else{
                that.baseMap = L.map(that.initId, {
                    center: [0,0],
                    maxZoom: 18,
                    zoomControl:false,
                    attributionControl:false,
                    zoom: 1,
                });
            }
            that.TimeLayerGroup = L.layerGroup().addTo(that.baseMap);
            that.windLayerGroup = L.layerGroup().addTo(that.baseMap);
            that.measureGroup = L.layerGroup().addTo(that.baseMap);
            var url = initmapUlr + that.collections[0].underPaintingUrl
            tiledMapLayer(url,{
                noWrap:true
            }).addTo(this.baseMap);
            await this.clearAllCache()
            let layersID =  await this.getLyaerId('SMID=1')
            tiledMapLayer(this.iserverHeader +this.url + '/'+ this.collections[0].resourceName, {
                noWrap: true,
                layersID:layersID
            }).addTo(this.TimeLayerGroup);
        },
        async getLyaerId(filterValue){
            let that = this
            let url = this.iserverHeader +that.url + '/'+that.collections[0].resourceName + '/tempLayersSet.json'
            that.currentParams = that.collections[0].xqOption
            that.currentParams[0].subLayers.layers[0].subLayers.layers.forEach(item =>{
                item.displayFilter = filterValue
            })
            let res = await addLeafletLayerFromOption(url,that.currentParams)
            return JSON.parse(res).newResourceID
            
        },
        async getTimeList(){
            let that = this
            this.loading = true
            const startTime = this.changeTime(this.timeRange[0]) + ' 00:00:00'
            const endTime = this.changeTime(this.timeRange[1]) + ' 23:59:59'
            const dataURL = this.iserverHeader+"/iserver/services/data-hyyg_data/rest/data/featureResults.rjson?returnContent=true";
            let sqlstring = 'createtime Between\'' + startTime + '\' AND \'' + endTime + '\''
            let res = await axios.post(dataURL, {
                datasetNames: [
                    "hyyg_data" + ":" + that.collections[0].resourceName,
                ],
                getFeatureMode: "SQL",
                queryParameter: {
                    attributeFilter: sqlstring,
                    fields:["createtime"]
                },
                hasGeometry: false
            })
            that.timelist = res.data.features.map(item =>{
                return item.fieldValues[0]
            })
            let a = []
            await Promise.all(that.timelist.map(async item =>{
                let layersOne =  await this.getLyaerId("createtime='"+item+"'")
                a.push(layersOne)
            }))
            that.layerIdList = a
            that.loading = false
            that.TimeLayerGroup.clearLayers()
            
            //每次查询add最新的一个
            tiledMapLayer(that.iserverHeader +that.url + '/'+ that.collections[0].resourceName, {
                noWrap: true,
                layersID:that.layerIdList[0]
            }).addTo(this.TimeLayerGroup);
        },
        clearCacheLayer(){
            let that = this
            that.layerIdList.forEach(item =>{
                let dataURL = that.iserverHeader +that.url + '/'+that.collections[0].resourceName+"/tempLayersSet/"+item+"?_method=DELETE"
                axios.get(dataURL)
            })
        },
        async clearAllCache(){
            let that = this
            //查询所有layerid
            const dataURL = that.iserverHeader +that.url + '/'+that.collections[0].resourceName+"/tempLayersSet.json";
            let res = await axios.get(dataURL)
            console.log(res);
            //清楚所有
            res.data.map(item =>{
                let dataURL = that.iserverHeader +that.url + '/'+that.collections[0].resourceName+"/tempLayersSet/"+item.name+"?_method=DELETE"
                axios.get(dataURL)
            })
            //保留最后一个
        },
        creatWind(){
            let that = this
            if(!this.initWind){
                axios.get('config/wind-global.json').then(res => {
                    if (res.data) {
                        let datas = res.data
                        let velocityLayer = L.velocityLayer({
                            displayValues: true,
                            displayOptions: {
                                velocityType: 'GBR Wind',
                                displayPosition: 'bottomleft',
                                displayEmptyString: 'No wind data'
                            },
                            data: datas,//风场数据
                            minVelocity: 0, //Velocity：速率
                            maxVelocity: 10,
                            velocityScale: 0.01,
                            particleMultiplier: 1 / 1200,//粒子的数量
                            lineWidth: 2,                     //粒子的粗细
                            frameRate: 15,                      //定义每秒执行的次数
                            colorScale: [
                                "rgb(254,224,139)",
                                "rgb(171,221,164)",
                                "rgb(104,196,160)",
                                "rgb(44,185,156)",
                                "rgb(25,169,178)",
                                "rgb(50,136,189)",
                                "rgb(31,110,183)",
                                "rgb(5,98,184)"]
                        });
                        velocityLayer.addTo(that.windLayerGroup); //添加到图上
                        that.initWind = true
                        that.showWind = true
                    }
                })
            }else{
                that.windLayerGroup.clearLayers()
                that.initWind = false
                that.showWind = false
            }

        }
    },

    created(){
    },
    mounted(){
        this.initMap()
        this.$nextTick(() =>{
            this.renderLegend()
        })
    }
}
</script>

<style lang="scss" scoped>
.map{
    width: 100%;
    height: 100%;
    .legend-my{
        position: absolute;
        left: 0;
        bottom: 6px;
        padding-left: 12px;
        z-index: 100000;
        .right{
            position: absolute;
            left: 36px;
            top: 0;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 160px;
            p{
                width: 47px;
                display: inline;
            }
        }
        .legend-show{
            width: 24px;
            height: 160px;
        }
    }
    .time-step{
        position: absolute;
        left: 260px;
        bottom: 10px;
        z-index: 100000;
    }
}
/deep/.iclient-leaflet-logo{
    display: none;
}
</style>
